import React from 'react';

export default function Template() {
  return (
    <div>
      <p>Choose “Yes” if applicable, additional documentation such as IRS Form W-8BEN-E may be required</p>
      <p>
        Select “Yes” if any of the following persons are among the owners of your company (holding more than 10%) or its
        directors:
      </p>
      <ol>
        <li>U.S. citizens (including those with dual citizenship);</li>
        <li>individuals holding a U.S. residence permit (Green Card);</li>
        <li>U.S. tax residents (i.e., individuals who reside in the United States for more than 183 days per year);</li>
      </ol>
      <p>If no such persons are part of the company’s structure, select “No”.</p>
    </div>
  );
}
